import { getCoatHangerIconSvg } from './CoatHangerIcon';
import { getCoverIconSvg } from './CoverIcon';
import { getDoorsIconSvg } from './DoorsIcon';
import { getFramesIconSvg } from './FramesIcon';
import { getHandPointIconSvg } from './HandPointIcon';
import { getInteriorsIconSvg } from './InteriorsIcon';
import { getSectionsIconSvg } from './SectionsIcon';
import { getShelvingUnitsIconSvg } from './ShelvingUnitsIcon';
import { getTablesIconSvg } from './TablesIcon';
import { getTrashcanIconSvg } from './TrashcanIcon';
import { getUprightsIconSvg } from './UprightsIcon';
import { getWallMeasurementIconSvg } from './WallMeasurementIcon';
import { getWheelsIconSvg } from './WheelsIcon';

export default function getCustomIcon(iconName: string) {
  let customIconSvg: string | undefined = undefined;

  switch (iconName) {
    case 'CoatHangerIcon':
      customIconSvg = getCoatHangerIconSvg();
      break;
    case 'CoverIcon':
      customIconSvg = getCoverIconSvg();
      break;
    case 'DoorsIcon':
      customIconSvg = getDoorsIconSvg();
      break;
    case 'FramesIcon':
      customIconSvg = getFramesIconSvg();
      break;
    case 'HandPointIcon':
      customIconSvg = getHandPointIconSvg();
      break;
    case 'InteriorsIcon':
      customIconSvg = getInteriorsIconSvg();
      break;
    case 'SectionsIcon':
      customIconSvg = getSectionsIconSvg();
      break;
    case 'ShelvingUnitsIcon':
      customIconSvg = getShelvingUnitsIconSvg();
      break;
    case 'TablesIcon':
      customIconSvg = getTablesIconSvg();
      break;
    case 'TrashcanIcon':
      customIconSvg = getTrashcanIconSvg();
      break;
    case 'UprightsIcon':
      customIconSvg = getUprightsIconSvg();
      break;
    case 'WallMeasurementIcon':
      customIconSvg = getWallMeasurementIconSvg();
      break;
    case 'WheelsIcon':
      customIconSvg = getWheelsIconSvg();
      break;
    default:
      break;
  }
  return customIconSvg;
}
